import type { ReactNode } from "react";
import { ChevronLeft } from "lucide-react";
import { cn } from "./cn";
import { UiLink } from "./router";

export function PageHeader({
  title,
  description,
  actions,
  back,
  eyebrow,
  className,
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
  back?: { href: string; label: string };
  eyebrow?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("mb-6 sm:mb-8", className)}>
      {back ? (
        <UiLink
          href={back.href}
          className="mb-3 inline-flex items-center gap-1 text-sm font-semibold text-brand hover:text-brand-strong"
        >
          <ChevronLeft className="size-3.5" aria-hidden />
          {back.label}
        </UiLink>
      ) : null}
      <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-4">
        <div className="min-w-0">
          <h1 className="font-display text-3xl font-bold tracking-[-0.025em] text-ink">
            {title}
          </h1>
          {eyebrow ? <div className="mt-1.5">{eyebrow}</div> : null}
          {description ? (
            <p className="mt-2 max-w-2xl text-base text-ink-3">{description}</p>
          ) : null}
        </div>
        {actions ? (
          <div className="flex flex-wrap items-center gap-2">{actions}</div>
        ) : null}
      </div>
    </div>
  );
}
